import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseParamsService } from '@app/core/base-params.service';
import { environment } from '@env/environment';
import { map, retry } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { LOYALTY_CLUB_SLUG_HEADER } from '@app/core/consts';
import { WithRedirectUrl } from '@app/core/_models/redirectUrl';


interface SpaycialStatus {
  active: boolean;
  scanUser: boolean;
}

interface SpaycialStatusResponse {
  active: boolean;
  scan_user: boolean;
}


@Injectable()
export class SpaycialIntegrationApiService {
  private http = inject(HttpClient);
  private baseParamsService = inject(BaseParamsService);


  private path = `${environment.webforms_api}/v1/members/me/integrations/spaycial`;

  public isConnected(): Observable<SpaycialStatus> {
    return this.http.get(
      `${this.path}/status`,
      { headers: this.prepareHeaders() },
    ).pipe(
      retry(3),
      map(
        (response: SpaycialStatusResponse) => ({ active: response.active, scanUser: response.scan_user }),
      ),
    );
  }

  public connect(callbackUrl?: string): Observable<string> {
    return this.getRedirectUrlFrom('connect', callbackUrl);
  }

  public disconnect(): Observable<void> {
    return this.http.delete(
      this.path,
      { headers: this.prepareHeaders() },
    ).pipe(
      map(() => { return; }),
    );
  }

  public getConnections(callbackUrl: string): Observable<string> {
    return this.getRedirectUrlFrom('connections', callbackUrl);
  }

  public getActivities(callbackUrl: string): Observable<string> {
    return this.getRedirectUrlFrom('customers/activities', callbackUrl);
  }

  public getOffers(callbackUrl?: string): Observable<string> {
    return this.getRedirectUrlFrom('offers', callbackUrl);
  }

  public getProfile(callbackUrl?: string): Observable<string> {
    return this.getRedirectUrlFrom('profile', callbackUrl);
  }

  private getRedirectUrlFrom(path: string, callbackUrl?: string): Observable<string> {
    return this.http.post(
      `${this.path}/${path}`,
      {
        callback_url: callbackUrl,
      },
      { headers: this.prepareHeaders() },
    ).pipe(
      map((response: WithRedirectUrl) => response.redirect_url),
    );
  }

  private prepareHeaders(): HttpHeaders {
    let headers = this.baseParamsService.getAuthHeadersWithAutologin() || new HttpHeaders();
    headers = headers.set(LOYALTY_CLUB_SLUG_HEADER, this.baseParamsService.slug);
    return headers;
  }
}
